export const byNumber = (a: number, b: number) => {
  return a === b ? 0 : a > b ? -1 : 1;
};
